import axios from 'axios';
import { useEffect, useState } from 'react';
import Footer from '../component/Footer';

export default function Method() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchImages = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/setting/document`, { params: { type: 'method' } });
            setImages(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const steps = [
        { number: '01', title: 'Listen First', desc: 'Nghe bài Main Story nhiều lần. Đừng cố dịch từng từ, hãy để não bộ quen dần với âm thanh tiếng Anh một cách tự nhiên.', color: 'from-blue-500 to-blue-700' },
        { number: '02', title: 'Vocabulary Lesson', desc: 'Nghe bài Vocabulary để hiểu nghĩa các từ mới trong ngữ cảnh. Cách này giúp bạn nhớ từ vựng lâu hơn so với việc học thuộc lòng.', color: 'from-green-500 to-green-700' },
        { number: '03', title: 'Mini-Story Lesson', desc: 'Nghe và trả lời các câu hỏi trong Mini-Story. Đây là phần quan trọng nhất, giúp bạn xây dựng phản xạ giao tiếp.', color: 'from-purple-500 to-purple-700' },
        { number: '04', title: 'Point of View Story', desc: 'Nghe cùng câu chuyện ở nhiều thì khác nhau. Bạn sẽ tự nhiên nắm được ngữ pháp mà không cần học quy tắc.', color: 'from-orange-500 to-orange-700' },
        { number: '05', title: 'Deep Learning', desc: 'Lặp lại mỗi bài ít nhất 7 ngày liên tục trước khi chuyển sang bài mới. Sự lặp lại là chìa khóa của deep learning.', color: 'from-red-500 to-red-700' },
    ];

    return (
        <>
            <div className="min-h-screen bg-[#0a1628]">
                {/* Hero */}
                <div className="bg-gradient-to-r from-[#0f1e35] to-[#1a2d4a] text-white py-20 border-b border-white/10">
                    <div className="max-w-screen-xl mx-auto px-6 text-center">
                        <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Phương Pháp Effortless English</h1>
                        <p className="text-lg text-blue-300 max-w-3xl mx-auto">Phương pháp học tiếng Anh tự nhiên được phát triển bởi A.J. Hoge — giúp bạn nói tiếng Anh tự tin mà không cần học ngữ pháp</p>
                    </div>
                </div>

                <div className="max-w-screen-xl mx-auto px-6 py-12">
                    {/* Intro */}
                    <div className="bg-[#0f1e35] border border-white/10 rounded-2xl p-8 md:p-12 mb-12">
                        <h2 className="text-3xl font-bold text-white mb-6 text-center">Tại sao Effortless English hiệu quả?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="text-center p-6 rounded-xl bg-blue-500/10 border border-blue-500/20">
                                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-blue-500 flex items-center justify-center text-white text-2xl font-bold">🎧</div>
                                <h3 className="font-bold text-lg mb-2 text-white">Học qua nghe</h3>
                                <p className="text-gray-400 text-sm">Tập trung vào kỹ năng nghe giúp bạn phát triển phản xạ ngôn ngữ tự nhiên</p>
                            </div>
                            <div className="text-center p-6 rounded-xl bg-green-500/10 border border-green-500/20">
                                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-500 flex items-center justify-center text-white text-2xl font-bold">🗣️</div>
                                <h3 className="font-bold text-lg mb-2 text-white">Nói tự nhiên</h3>
                                <p className="text-gray-400 text-sm">Sau khi nghe đủ, bạn sẽ tự động nói tiếng Anh mà không cần suy nghĩ</p>
                            </div>
                            <div className="text-center p-6 rounded-xl bg-purple-500/10 border border-purple-500/20">
                                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-purple-500 flex items-center justify-center text-white text-2xl font-bold">🧠</div>
                                <h3 className="font-bold text-lg mb-2 text-white">Deep Learning</h3>
                                <p className="text-gray-400 text-sm">Lặp lại nhiều lần giúp kiến thức đi vào tiềm thức, nhớ lâu hơn</p>
                            </div>
                        </div>
                    </div>

                    {/* Steps */}
                    <h2 className="text-3xl font-bold text-white mb-8 text-center">Các bước học theo phương pháp</h2>
                    <div className="space-y-6 mb-12">
                        {steps.map((step, index) => (
                            <div key={index} className="flex items-stretch gap-6 bg-[#0f1e35] border border-white/10 rounded-xl overflow-hidden hover:border-white/20 transition-all">
                                <div className={`bg-gradient-to-br ${step.color} text-white flex items-center justify-center min-w-[100px] text-3xl font-extrabold`}>
                                    {step.number}
                                </div>
                                <div className="py-6 pr-6">
                                    <h3 className="text-xl font-bold text-white mb-2">{step.title}</h3>
                                    <p className="text-gray-400">{step.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Image Gallery */}
                    {!loading && images.length > 0 && (
                        <div className="mb-12">
                            <h2 className="text-3xl font-bold text-white mb-8 text-center">Hình ảnh minh họa</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {images.map((img, index) => (
                                    <div key={index} className="rounded-xl overflow-hidden border border-white/10 hover:border-white/20 transition-all">
                                        <img src={img.url} alt={`Method ${index + 1}`} className="w-full h-64 object-cover" crossOrigin="anonymous" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* CTA */}
                    <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-12 text-white text-center">
                        <h2 className="text-3xl font-bold mb-4">Sẵn sàng bắt đầu học?</h2>
                        <p className="text-blue-200 mb-6 max-w-2xl mx-auto">Hãy chọn khóa học phù hợp và bắt đầu hành trình chinh phục tiếng Anh của bạn ngay hôm nay!</p>
                        <a href="/topic" className="inline-block bg-white text-blue-600 font-bold px-8 py-3 rounded-full hover:bg-blue-50 transition-colors shadow-lg">Xem khóa học →</a>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
